import React from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';
import Icon from '../../Icon';
import TooltipContainer from '../../TooltipContainer';

export default class DeleteItemButton extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {deleting: false, modal: false};
        this.handleClosed = this.handleClosed.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    handleDelete() {
        // Restore when https://github.com/reactstrap/reactstrap/issues/1819 is fixed
        // this.setState({modal: false}, () => this.props.onClick());
        this.setState({deleting: true, modal: false});
    }

    toggleModal() {
        this.setState({modal: !this.state.modal});
    }

    handleClosed() {
        if (this.state.deleting) {
            this.setState({deleting: false}, () => this.props.onClick());
        }
    }

    render() {
        const {itemId} = this.props;
        return (
            <TooltipContainer component="button" className="btn btn-link border-left" type="button" onClick={this.toggleModal}
                tooltip={messages.surveys.tooltips.deleteQuestion}>
                <Icon icon="trash" type="danger" />
                <Modal isOpen={this.state.modal} toggle={this.toggleModal} onClosed={this.handleClosed}>
                    <ModalHeader toggle={this.toggleModal}>
                        <FormattedMessage {...messages.surveys.modals.removePage.title} values={{id: itemId}} />
                    </ModalHeader>
                    <ModalBody>
                        <FormattedMessage {...messages.surveys.modals.removePage.body} values={{id: itemId}} />
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-outline-secondary mr-auto" type="button" onClick={this.toggleModal}>
                            <FormattedMessage {...messages.buttons.cancel} />
                        </button>
                        <button className="btn btn-primary delete-button" type="button" onClick={this.handleDelete}>
                            <Icon icon="trash" /><FormattedMessage {...messages.surveys.button.remove} />
                        </button>
                    </ModalFooter>
                </Modal>
            </TooltipContainer>
        );
    }
}
